import { type ReactNode } from 'react';

interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  message: string;
}

export function EmptyState({ icon, title, message }: EmptyStateProps) {
  return (
    <div className="bg-neut-bg-alt rounded-lg border border-neut-border p-12 text-center w-full flex flex-col items-center justify-center">
      <div className="mx-auto text-neut-400 mb-4">{icon}</div>
      <h3 className="text-lg text-neut-prim font-semibold mb-2">{title}</h3>
      <p className="text-neut-sec">{message}</p>
    </div>
  );
}
